import { ReactElement } from 'react';

import { PatientConsentDocument } from '@dreryk/egabinet-patient-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import {
   AttachmentsTable,
   Modal,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   TextView,
} from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

const t = patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.patientConsentDocumentsModal;

type ConsentsAndAuthorizationsDocumentAttachmentsModalProps = {
   readonly name: PatientConsentDocument['name'];
   readonly attachments: PatientConsentDocument['attachments'];
   readonly onClose: VoidFunction;
};

export const ConsentsAndAuthorizationsDocumentAttachmentsModal = (
   props: ConsentsAndAuthorizationsDocumentAttachmentsModalProps
): ReactElement => {
   return (
      <Modal
         title={createTranslatedText(props.name)}
         onCloseRequest={props.onClose}
         width={ModalWidth.NORMAL}
         testId={'patientConsentDocumentsModal'}
      >
         <TextView label={t.table.label} testId={'attachments'}>
            <AttachmentsTable data={props.attachments ?? null} testId={'attachments'} />
         </TextView>
         <ModalCloseButton onClick={props.onClose} />
         <ModalConfirmButton onClick={props.onClose} label={t.actions.close} />
      </Modal>
   );
};
